const commonProps = () => ({
  info: {
    type: Object,
    default: null,
  },
});

export default commonProps;
